import { render, staticRenderFns } from "./icon.vue?vue&type=template&id=3e1b6bec&"
import script from "./icon.vue?vue&type=script&lang=ts&"
export * from "./icon.vue?vue&type=script&lang=ts&"
import style0 from "./icon.vue?vue&type=style&index=0&id=3e1b6bec&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports